"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeTypeToAllowNegative = void 0;
const enums_1 = require("../enums");
exports.AttributeTypeToAllowNegative = {
    [enums_1.AttributeType.AllDamageImmunity]: true,
    [enums_1.AttributeType.FireDamageImmunity]: true,
    [enums_1.AttributeType.FrostDamageImmunity]: true,
    [enums_1.AttributeType.NatureDamageImmunity]: true,
    [enums_1.AttributeType.DeathDamageImmunity]: true,
    [enums_1.AttributeType.HolyDamageImmunity]: true,
    [enums_1.AttributeType.ChaosDamageImmunity]: true,
    [enums_1.AttributeType.SonicDamageImmunity]: true,
    [enums_1.AttributeType.PhysicalDamageImmunity]: true,
    [enums_1.AttributeType.AllDamageResistance]: true,
    [enums_1.AttributeType.FireDamageResistance]: true,
    [enums_1.AttributeType.FrostDamageResistance]: true,
    [enums_1.AttributeType.NatureDamageResistance]: true,
    [enums_1.AttributeType.DeathDamageResistance]: true,
    [enums_1.AttributeType.HolyDamageResistance]: true,
    [enums_1.AttributeType.ChaosDamageResistance]: true,
    [enums_1.AttributeType.SonicDamageResistance]: true,
    [enums_1.AttributeType.PhysicalDamageResistance]: true,
    [enums_1.AttributeType.AllDamagePercentIncrease]: true,
    [enums_1.AttributeType.FireDamagePercentIncrease]: true,
    [enums_1.AttributeType.FrostDamagePercentIncrease]: true,
    [enums_1.AttributeType.NatureDamagePercentIncrease]: true,
    [enums_1.AttributeType.DeathDamagePercentIncrease]: true,
    [enums_1.AttributeType.HolyDamagePercentIncrease]: true,
    [enums_1.AttributeType.ChaosDamagePercentIncrease]: true,
    [enums_1.AttributeType.SonicDamagePercentIncrease]: true,
    [enums_1.AttributeType.PhysicalDamagePercentIncrease]: true,
};
